export default class DatePickingModalCtrl {
  constructor($filter, $scope, blConfirmService, ngDialog) {
    this.$filter = $filter;
    this.$scope = $scope;
    this.blConfirmService = blConfirmService;
    this.ngDialog = ngDialog;
  }

  $onInit() {
    this.currentDate = new Date();
    this.startDate = this.calculateStartDate();
    this.endDate = this.calculateEndDate();
  }

  getDateFromDateString(dateString) {
    if (dateString) {
      const year = parseInt(dateString.slice(0, 4), 10);
      const month = parseInt(dateString.slice(4, 6), 10) - 1;
      const day = parseInt(dateString.slice(6, 8), 10);

      return new Date(year, month, day);
    }
  }

  calculateStartDate() {
    if (this.minDateAllowed) {
      return this.minDateAllowed;
    }
    return new Date(this.currentDate.getFullYear(), 0, 1);
  }

  calculateEndDate() {
    if (this.maxDateAllowed) {
      return this.maxDateAllowed;
    }
    return this.currentDate;
  }

  formatDate(date, separator) {
    return this.$filter('date')(date, `yyyy${separator}MM${separator}dd`);
  }

  dateInputError() {
    if (!this.startDate) {
      return 'Beginning date is incorrect';
    }
    if (!this.endDate) {
      return 'Ending date is incorrect';
    }
    if (this.endDate < this.startDate) {
      return 'Ending date cannot be before the first one';
    }
    if (this.endDate > this.currentDate) {
      return 'Ending date cannot be greater than today';
    }

    // If min and max range getters provided
    if (this.minDateAllowed && this.maxDateAllowed) {
      if (this.minDateAllowed && this.startDate < this.minDateAllowed) {
        return `Beginning date cannot be before  ${this.minDateAllowed.toDateString()}`;
      }
      if (this.maxDateAllowed && this.endDate > this.maxDateAllowed) {
        return `Ending date cannot be greater than ${this.maxDateAllowed.toDateString()}`;
      }
    }
    return undefined;
  }

  handleConfirm() {
    if (this.minValidDate && this.startDate < new Date(this.minValidDate)) {
      this.dateError = `Start date cannot be before ${new Date(this.minValidDate).toDateString()}`;
      return;
    }
    this.dateError = '';
    const formattedStartDate = this.formatDate(this.startDate, '-');
    const formattedEndDate = this.formatDate(this.endDate, '-');
    this.onConfirm({ startDateString: formattedStartDate, endDateString: formattedEndDate });
    this.closeThisDialog('confirm');
  }

  closeThisDialog(value) {
    if (value === 'cancel' && this.$scope.$parent?.vm?.isSyncing)
      this.$scope.$parent.vm.isSyncing = false;
    this.ngDialog.close();
  }
}
